import React from 'react';
import bannerimg from '../../../assets/images/chair.png';

const Banner = () => {
    return (
        <div className="hero  relative my-28">
            <div className="hero-content flex-col lg:flex-row-reverse">
                <img src={bannerimg} className="h-auto lg:w-1/2 relative rounded-lg shadow-2xl" />
                <div>
                    <h1 className="lg:text-5xl font-bold">Your New Smile Starts Here!</h1>
                    <p className="py-6">Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a id nisi.</p>
                    <button className="btn btn-accent text-white">Get Started</button>
                </div>
            </div>
        </div>
    );
};

export default Banner;